import { createSlice, PayloadAction } from '@reduxjs/toolkit'; 

interface FreeDomain {
    freedomain: any;
    isLoading: Boolean;
    error: string | null;
}

const initialState: FreeDomain = {
    freedomain: null,
    isLoading: false,
    error: null,
};

const freeDomainSlice = createSlice({
    name: 'freeDomain',
    initialState,
    reducers: {
        setFreeDomain: (state: FreeDomain, action: PayloadAction<FreeDomain>) => {
            state.freedomain = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        isloading: (state: FreeDomain, action: PayloadAction<Boolean>) => {
            state.isLoading = action.payload;
            state.error = null;
        },
        seterror: (state: FreeDomain, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        resetFreeDomain: () => {
            return initialState;
        },
    },
});

export const { setFreeDomain, isloading, seterror, resetFreeDomain } = freeDomainSlice.actions;

export default freeDomainSlice.reducer;